var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.432 0A4.437 4.437 0 000 4.432v6.136A4.437 4.437 0 004.432 15h6.136A4.437 4.437 0 0015 10.568V4.432A4.437 4.437 0 0010.568 0H4.432zm0 .682h6.136a3.745 3.745 0 013.75 3.75v6.136a3.745 3.745 0 01-3.75 3.75H4.432a3.745 3.745 0 01-3.75-3.75V4.432a3.745 3.745 0 013.75-3.75zm7.159 2.045a.682.682 0 100 1.364.682.682 0 000-1.364zM7.5 3.75A3.755 3.755 0 003.75 7.5a3.755 3.755 0 003.75 3.75 3.755 3.755 0 003.75-3.75A3.755 3.755 0 007.5 3.75zm0 .682A3.063 3.063 0 0110.568 7.5 3.063 3.063 0 017.5 10.568 3.063 3.063 0 014.432 7.5 3.063 3.063 0 017.5 4.432z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.25
  })));
}

export default SvgCommonIconInstagram;